import { CSSProperties, FC, ReactNode } from 'react';
import { Avatar, Typography } from 'antd';
import { TbIconsOff } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { OurDocsLink } from '@/shared/components/tags';

interface UnsupportedComponentTypeProps {
    action?: ReactNode;
    description?: ReactNode;
    icon?: ReactNode;
    style?: CSSProperties;
    title?: ReactNode;
}

const UnsupportedComponentType: FC<UnsupportedComponentTypeProps> = ({
    action,
    description,
    icon,
    style,
    title = 'Unsupported Component',
}) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                padding: '1.5rem',
                textAlign: 'center',
                width: '100%',
                ...style,
            }}
        >
            <Avatar
                size={40}
                shape='square'
                icon={icon ?? <TbIconsOff size='75%' style={{ color: token.colorTextTertiary }} />}
                style={{
                    background: token.colorBgContainer,
                    border: `1px solid ${token.colorBorder}`,
                    marginBottom: '0.5rem',
                }}
            />
            <Typography.Text style={{ display: 'block', marginBottom: '0.25rem' }}>{title}</Typography.Text>
            <small style={{ color: token.colorTextTertiary, maxWidth: '32rem' }}>
                {description ?? (
                    <>
                        This component is currently unsupported. If this is an error, please{' '}
                        <OurDocsLink text='contact us' />.
                    </>
                )}
            </small>
            {action}
        </div>
    );
};

export default UnsupportedComponentType;
